import { Empty, Spin } from 'antd'
import AntdAvatar from 'components/Avatar'
import Pagination from 'components/Pagination'
import {
  RowNumberData,
  RowNumberDataCompany,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import React, { useState, useEffect } from 'react'
import { FlexWrap } from '../../../../components/TableStyles/TableContentStyles'
import { toCamelCase } from '../../../../utils/camelCase'
import { fixedSorterColumn } from '../../../../utils/constants'
import { EmptyWrapper, NavWrapper } from '../../../Corporates/Style/style'
import CollegeStatus from './CollegeStatus'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { fetchFeatureInstitutes } from '../../actions'
import { useNavigate } from 'react-router-dom'

const NameWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const NameText = styled.span`
  font-size: 15px;
  font-weight: 500;
  color: #3249D7;
  cursor: pointer;
`

const LocationText = styled.span`
  color: #000000;
  font-size: 15px;
  display: inline;
  margin-left: 4px;
`

const CollegeTable = ({
  collegeList,
  corporateList,
  instituteList,
  current, // true for Corporates, false for Institutes
   page,
  search,
  loading,
  onPageChange,
  setSearch,
  setSort,
  setOrderBy,
  orderBy,
  sortBy,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
 
  //const [instituteList, setInstituteList] = useState([])
  //const [corporateList, setCorporateList] = useState([])

  const onSorting = (pagination, row, sorter) => {
    let order = ''
    if (sorter.order === 'descend') {
      order = 'desc'
      setSort(sorter?.field)
    } else if (sorter.order === 'ascend') {
      order = 'asc'
      setSort(sorter?.field)
    } else {
      setSort('')
    }
    setOrderBy(order)
  }
 

  const columns = [
    {
      title: current ? 'CORPORATE NAME' : 'COLLEGE NAME',
      dataIndex: 'name',
      key: 'college_name',
      width: '50%',
      sorter: true,
      showSorterTooltip: fixedSorterColumn(orderBy),
      render: (_, rowData) => {
        // Get the name from the data
        const name = rowData?.name ? toCamelCase(rowData.name) : '';
        
        // Get city based on current type (corporate vs institute)
        let city = '';
        if (current) {
          // For corporates, city is directly on the row data
          city = rowData?.city || '';
        } else {
          // For institutes, get city from instituteCampus if available
          city = rowData?.instituteCampus && rowData.instituteCampus[0]?.city ? rowData.instituteCampus[0].city : '';
        }
        
        // Handle navigation when clicking on the name
        const handleNameClick = () => {
          if (current) {
            // For corporates, navigate to corporate route with corporate ID
            navigate(`/assessmentAssignSubscription/corporate/${rowData.id}`);
          } else {
            // For institutes, navigate to institute route with institute campus ID
            const campusId = rowData?.id;
            if (campusId) {
              navigate(`/assessmentAssignSubscription/institute/${campusId}`);
            }
          }
        };
        
        const CollegeItem = (
          <FlexWrap alignCenter gap="14px">
            <AntdAvatar
              src={rowData?.logo}
              size={37}
              IconName={name.charAt(0)}
              font={18}
            />
            <NameWrapper>
              <NameText onClick={handleNameClick}>{name}</NameText>
              {city && <LocationText>, {city}</LocationText>}
            </NameWrapper>
          </FlexWrap>
        )
        return CollegeItem
      },
    },
    // {
    //   title: 'POC CONTACT DETAILS',
    //   dataIndex: 'contact',
    //   key: 'contact',
    //   width: '30%',
    //   render: (_, rowData) => (
    //     <div>
    //       <RowNumberData>{rowData?.contactNumber}</RowNumberData>
    //       <RowNumberData style={{ color: '#7B7B7B', fontSize: '12px' }}>{rowData?.email}</RowNumberData>
    //     </div>
    //   ),
    // },
    {
      title: 'ATS',
      dataIndex: 'atsStatus',
      key: 'atsStatus',
      render: (_, rowData) => {
        // Show active for accessLevel 1 or 3, dash for accessLevel 2
        const isActive = rowData?.accessLevel === 1 || rowData?.accessLevel === 3;
        return (
          <RowNumberData>
            <CollegeStatus status={isActive ? 1 : 0} />
          </RowNumberData>
        );
      },
    },
    {
      title: 'ASSMT.',
      dataIndex: 'assignmentStatus',
      key: 'assignmentStatus',
      render: (_, rowData) => {
        // Show active for accessLevel 2 or 3, dash for accessLevel 1
        const isActive = rowData?.accessLevel === 2 || rowData?.accessLevel === 3;
        return (
          <RowNumberData>
            <CollegeStatus status={isActive ? 1 : 0} />
          </RowNumberData>
        );
      },
    },
  ]

  return (
    <NavWrapper column>
      <StyledTable
        columns={columns}
        onChange={onSorting}
        dataSource={current ? corporateList?.list : instituteList?.result}
        pagination={false}
        locale={{
          emptyText: (
            <EmptyWrapper center isSpin={loading}>
              {!loading ? (
                <Empty description={current ? 'No corporates found!' : 'No colleges found!'} />
              ) : (
                <Spin />
              )}
            </EmptyWrapper>
          ),
        }}
      />
      {!loading && (current ? corporateList?.count : instituteList?.count) > 0 && (
        <Pagination
          onChange={onPageChange}
          totalPages={current ? corporateList?.count : instituteList?.count}
          pageSize={10}
          current={page + 1}
        />
      )}
    </NavWrapper>
  )
}

export default CollegeTable
